import React from 'react';

const ExitConfirmModal = ({ showExitConfirm, setShowExitConfirm, handleExitTest }) => {
  if (!showExitConfirm) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl p-6 max-w-sm w-full shadow-2xl">
        <div className="text-center">
          <div className="text-base sm:text-lg font-semibold mb-4 text-gray-900">
            Are you sure you want to stop the test?
          </div>
          <div className="text-sm text-gray-600 mb-6">
            Your progress will be lost and you'll return to the main menu.
          </div>
          <div className="flex gap-3">
            <button
              onClick={() => setShowExitConfirm(false)}
              className="flex-1 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-colors text-sm sm:text-base"
            >
              Continue Test
            </button>
            <button
              onClick={handleExitTest}
              className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors text-sm sm:text-base"
            >
              Exit Test
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExitConfirmModal;